import { Pipe, PipeTransform } from '@angular/core';
import { DrawerPlacement } from '@shared/shared/drawers/common/constants/drawer-placement';
import { DrawerOptions } from '@shared/shared/drawers/common/interfaces/drawer-options';

@Pipe({
  name: 'drawerDataToClassList',
  standalone: false
})
export class DrawerDataToClassListPipe implements PipeTransform {
  transform<C>(drawerData: DrawerOptions<C>): string[] {
    const classList = drawerData?.drawerWrapperClassName ? [drawerData.drawerWrapperClassName] : [];
    classList.push(drawerData.placement ?? DrawerPlacement.right);
    return classList;
  }
}
